import { ofType } from 'redux-observable';
import { switchMap } from 'rxjs/operators/switchMap';
import { map } from 'rxjs/operators/map';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { LocationService } from '../../services';
import { locationEditedAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.EDIT_LOCATION),
    switchMap(action =>
      LocationService.edit(action.location, store).pipe(
        map(data => locationEditedAction(data)),
        catchError(retryAuthentication(action$, 'epics/locations/locationEdit'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/locations/locationEdit.js